(function(){
  function moneyToNumber(s){
    if (!s) return 0;
    var n = parseFloat(String(s).replace(/[^0-9.]/g,''));
    return isNaN(n) ? 0 : n;
  }
  /* Format mirroring the source — keeps decimals if the source has them. */
  function fmtForSource(value, sourceText){
    var hasDecimal = /\.\d{2}/.test(sourceText || '');
    if (hasDecimal || (value % 1) !== 0){
      return '$' + (Math.round(value * 100) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return '$' + Math.round(value).toLocaleString('en-US');
  }
  function fmtMoneyCents(cents){
    var n = (cents || 0) / 100;
    return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ─── Step 3 sticky ATC ──────────────────────────────────────────
     Computes "Your ring" = native productprice + cart refinements.
     Self-sufficient — fetches /cart.js directly so it doesn't depend
     on any other snippet's grand-total span being rendered first. */
  if (!window.__spFinalStickyInit){
    window.__spFinalStickyInit = true;

    var cachedRefDollars = 0;

    function fetchRefinementDollars(){
      return fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var cents = 0;
        (cart.items || []).forEach(function(it){
          var p = it.properties || {};
          if (p._extra_type){
            cents += (it.final_line_price != null ? it.final_line_price
                    : (it.line_price != null ? it.line_price
                    : (it.price * (it.quantity || 1))));
          }
        });
        cachedRefDollars = cents / 100;
        return cachedRefDollars;
      })
      .catch(function(){ return cachedRefDollars; });
    }

    var atcInit = function(){
      if (!document.getElementById('finalmainsection')) return;
      var bar   = document.querySelector('[data-sp-sticky-atc]');
      var btn   = bar && bar.querySelector('[data-sp-sticky-atc-btn]');
      var price = bar && bar.querySelector('[data-sp-sticky-price]');
      if (!bar || !btn) return;
      document.body.classList.add('sp-final-sticky-active');
      bar.setAttribute('data-sp-sticky-on', 'true');
      bar.setAttribute('aria-hidden', 'false');
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var real = document.getElementById('addToCart');
        if (real) real.click();
      });

      function applyDisplay(){
        var nativeEl = document.querySelector('#finalmainsection #productprice')
                    || document.querySelector('#finalmainsection .price__on-sale');
        if (!nativeEl) return;
        var nativeText = (nativeEl.textContent || '').trim();
        var basePrice = moneyToNumber(nativeText);
        if (basePrice <= 0) return;
        var grand = basePrice + cachedRefDollars;
        var formatted = fmtForSource(grand, nativeText);
        if (price.textContent !== formatted) price.textContent = formatted;
      }

      function refresh(){
        fetchRefinementDollars().then(applyDisplay);
      }

      refresh();

      var nativeEl = document.querySelector('#finalmainsection #productprice')
                  || document.querySelector('#finalmainsection .price__on-sale');
      if (nativeEl && window.MutationObserver){
        var pending = false;
        var obs = new MutationObserver(function(){
          if (pending) return;
          pending = true;
          requestAnimationFrame(function(){ pending = false; applyDisplay(); });
        });
        obs.observe(nativeEl, { childList:true, subtree:true, characterData:true });
      }
      ['cart:updated','cart:refresh','cart:build','refresh:cart','cart.requestRefresh'].forEach(function(n){
        document.addEventListener(n, function(){ setTimeout(refresh, 120); });
      });
      var pollCount = 0;
      var poller = setInterval(function(){ applyDisplay(); if (++pollCount > 20) clearInterval(poller); }, 500);
    };
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', atcInit); } else { atcInit(); }
  }

  /* ─── Cart page sticky checkout ───────────────────── */
  if (!window.__spCartCheckoutInit){
    window.__spCartCheckoutInit = true;

    var cartInit = function(){
      var form = document.getElementById('CartPageForm');
      if (!form) return;  // not on cart page
      var bar       = document.querySelector('[data-sp-cart-checkout-bar]');
      var btn       = bar && bar.querySelector('[data-sp-cart-checkout-btn]');
      var totalEl   = bar && bar.querySelector('[data-sp-cart-total]');
      if (!bar || !btn) return;

      document.body.classList.add('sp-cart-sticky-active');
      bar.setAttribute('data-sp-on', 'true');
      bar.setAttribute('aria-hidden', 'false');

      btn.addEventListener('click', function(e){
        e.preventDefault();
        var termsBox = document.getElementById('CartTerms');
        if (termsBox && !termsBox.checked && form.getAttribute('data-terms-required') === 'true'){
          alert('Please accept the Terms & Conditions before checking out.');
          termsBox.focus();
          return;
        }
        var real = form.querySelector('.sw-cart__summary-card > button.sw-cart__checkout-btn')
                || form.querySelector('button[name="checkout"]');
        if (real){ real.click(); return; }
        var input = document.createElement('input');
        input.type = 'hidden'; input.name = 'checkout'; input.value = '';
        form.appendChild(input);
        if (typeof form.requestSubmit === 'function'){ form.requestSubmit(); }
        else { form.submit(); }
      });

      function refreshTotal(){
        fetch('/cart.js', {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        })
        .then(function(r){ return r.json(); })
        .then(function(cart){
          var totalCents = cart.total_price != null ? cart.total_price
                         : (cart.items_subtotal_price != null ? cart.items_subtotal_price : 0);
          var formatted = fmtMoneyCents(totalCents);
          if (totalEl.textContent !== formatted) totalEl.textContent = formatted;
        })
        .catch(function(){
          var el = document.querySelector('.sw-cart__summary-row--total span:last-child')
                || document.querySelector('[data-cart-total]')
                || document.querySelector('[data-cart-subtotal]');
          if (!el) return;
          var next = (el.textContent || '').trim();
          if (next && totalEl.textContent !== next) totalEl.textContent = next;
        });
      }

      refreshTotal();
      ['cart:refresh','cart:updated','cart:build','refresh:cart','cart.requestRefresh'].forEach(function(n){
        document.addEventListener(n, function(){ setTimeout(refreshTotal, 60); });
      });
      var polls = 0;
      var poller = setInterval(function(){
        refreshTotal();
        if (++polls > 10) clearInterval(poller);
      }, 1000);
    };
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', cartInit); } else { cartInit(); }
  }
})();
